import { createEvent, restore } from 'effector';
import type { User } from 'models';

export const LOCAL_STORAGE_KEY = 'user';

export const resetUser = createEvent();

export const setUser = createEvent<User | null>();
export const $user = restore(setUser, null).reset(resetUser);
